import axios from "axios";
import config from "../../config";

export const fetchRoutesByOrganization = async (organizationId) => {
  const response = await axios.get(
    `${config.baseURL}/route/organization?organizationId=${organizationId}`,
    { withCredentials: true }
  );

  return Array.isArray(response.data) ? response.data : [];
};

export const fetchStudentById = async (studentId) => {
  const response = await axios.get(`${config.baseURL}/student/id`, {
    params: { studentId },
    withCredentials: true,
  });

  return response.data?.student || null;
};

export const fetchStopsByOrganization = async (organizationId) => {
  const response = await axios.get(`${config.baseURL}/stop/organization`, {
    params: { organizationId },
    withCredentials: true,
  });

  return Array.isArray(response.data) ? response.data : [];
};

export const fetchVehiclesByOrganization = async (organizationId) => {
  const response = await axios.get(`${config.baseURL}/vehicle/organization`, {
    params: { organizationId },
    withCredentials: true,
  });

  return response.data?.vehicles || response.data || [];
};

export const uploadStudentProfilePicture = async (studentId, file) => {
  const formDataUpload = new FormData();
  formDataUpload.append("image", file);

  const response = await axios.post(
    `${config.baseURL}/upload/image?name=${encodeURIComponent(
      "StudentImage"
    )}&associateEntityId=${studentId}&associatedWith=Student&type=profile`,
    formDataUpload,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
    }
  );

  return response.data;
};

export const upsertParent = async ({
  parentId,
  firstName,
  lastName,
  phoneNumber,
  organizationId,
}) => {
  const response = await axios.post(
    `${config.baseURL}/parent/upsert`,
    {
      parentId,
      firstName,
      lastName,
      phoneNumber,
      organizationId,
    },
    { withCredentials: true }
  );

  return response.data;
};

export const fetchUnassignedNfcCards = async (organizationId) => {
  const response = await axios.get(`${config.baseURL}/device/nfc-cards`, {
    params: {
      status: "UNASSIGNED",
      ...(organizationId ? { organizationId } : {}),
    },
    withCredentials: true,
  });

  const cards = response.data?.data || response.data || [];
  return Array.isArray(cards) ? cards : [];
};

export const bindStudentNfcCard = async ({ studentId, nfcUid }) => {
  const response = await axios.post(
    `${config.baseURL}/student/nfc`,
    { studentId, nfcUid },
    { withCredentials: true }
  );

  return response.data;
};

export const replaceStudentNfcCard = async ({ studentId, nfcUid }) => {
  const response = await axios.put(
    `${config.baseURL}/student/${studentId}/nfc`,
    { nfcUid },
    { withCredentials: true }
  );

  return response.data;
};

export const unlinkStudentNfcCard = async (studentId) => {
  const response = await axios.delete(
    `${config.baseURL}/student/${studentId}/nfc`,
    { withCredentials: true }
  );

  return response.data;
};

export const syncStudentNfcCard = async ({
  studentId,
  nfcUid,
  previousNfcUid,
}) => {
  const nextUid = String(nfcUid || "").trim();
  const previousUid = String(previousNfcUid || "").trim();

  if (!studentId || nextUid === previousUid) {
    return null;
  }

  if (!nextUid) {
    return unlinkStudentNfcCard(studentId);
  }

  if (previousUid) {
    return replaceStudentNfcCard({ studentId, nfcUid: nextUid });
  }

  return bindStudentNfcCard({ studentId, nfcUid: nextUid });
};
